import React, {useEffect, useState} from 'react'
import ShowLink from "../../../common/ui/show-link";
import {getSingleQuote, searchQuotes} from "../../../common/services/quote-data-service";
import _ from 'lodash';
import Promise from "bluebird";
import {addSingleDesign, getSingleDesign, updateSingleDesign} from "../../services/design-data-service";
import {useParams} from "react-router-dom";
import ShowDesignDetail from "../common/show-design-detail";
import ShowTabsList from "../../../common/ui/show-tabs-list";
import {
    DEFAULT_DESIGN_EDITOR_TAB, DEFAULT_DESIGN_VARIANT_STATUS,
    DESIGN_EDITOR_TAB,
    DESIGN_EDITOR_TABS_LIST,
    DESIGN_KEY_PREFIX
} from "../../constants/design.constant";
import DesignVariantCardList from "../design-variant/design-variant-card-list";
import {
    addSingleDesignVariant, deleteSingleDesignVariant,
    getSingleDesignVariant,
    searchDesignVariants
} from "../../services/design-variant-data-service";
import {getSingleParentProduct, searchParentProducts} from "../../../pod/services/parent-product-data-service";
import {getNextItemKey} from "../../../common/utils/item-key-util";
import {PARENT_PRODUCT_FIELD_LIST, POD_KEY_PREFIX} from "../../../pod/constants/pod.constant";
import Editor from "./editor";
import {getAllTags, searchTags} from "../../../common/services/tag-data-service";
import {
    prepareImageFileName,
    processApplyTemplateStyle,
    processDesignVariantDetail, processImagesLayer,
    processTextItemsLayer
} from "../../utils/design-variant-util";
import ShowParentProductColorList from "../common/show-parent-product-color-list";
import {getSinglePod} from "../../../pod/services/pod-data-service";
import RenderFields from "../../../common/ui/render-fields";
import ParentProductDetail from "../../../pod/components/parent-product/edit-parent-product/parent-product-detail";
import {processDesignVariantStatistics} from "../../utils/design-util";
import {getAllQuoteTemplates} from "../../services/quote-template-data-service";
import DesignVariantItemList from "../design-variant/design-variant-item-list";
import DownloadDesignVariants from "../download/download-design-variants";

const tabsList = DESIGN_EDITOR_TABS_LIST;

const DesignEditor = () => {
    const {designId} = useParams();
    const [initialStep, setInitialStep] = useState(true);
    const [dataFetchInProgress, setDataFetchInProgress] = useState(false);
    const [parentProductColorsUpdated, setParentProductColorsUpdated] = useState(false);
    const [designDetail, setDesignDetail] = useState(null);
    const [quoteDetail, setQuoteDetail] = useState(null);
    const [parentProduct, setParentProduct] = useState(null);
    const [selectedTab, setSelectedTab] = useState(DEFAULT_DESIGN_EDITOR_TAB);
    const [selectedVariant, setSelectedVariant] = useState(null);
    const [selectedDesignBatchId, setSelectedDesignBatchId] = useState('');
    const [allTags, setAllTags] = useState([]);
    const [podDetail, setPodDetail] = useState(null);
    const [productColorMap, setProductColorMap] = useState(null);
    const [copiedVariantsCount, setCopiedVariantsCount] = useState(0);

    useEffect(() => {
        if (designId) {
            getDesignById();
            getTagsList();
        }
    }, [designId]);

    const getTagsList = async () => {
        const tagsListResult = await getAllTags();
        setAllTags(tagsListResult);
    }

    const getDesignById = async () => {
        getSingleDesign(designId)
            .then(async response => {
                const designDetailData = _.cloneDeep(response.data());
                designDetailData.id = designDetailData.id || designId;
                setDesignDetail(designDetailData);

                await getSingleParentProductByDesignDetail(designDetailData);

                if (_.isEmpty(designDetailData.variants)) {
                    await addNewDesignVariant(designDetailData);
                } else {
                    setSelectedVariant(designDetailData.variants[0]);
                }

                await getQuoteById(designDetailData.quoteId);
                await getPodDetailById(designDetailData.podId);

                console.log({designDetailData})
            });
    }

    const getSingleParentProductByDesignDetail = async (designDetailData) => {
        const searchCriteriaList = [];
        searchCriteriaList.push({field: 'podId', condition: '==', value: designDetailData?.podId});
        searchCriteriaList.push({field: 'market', condition: '==', value: designDetailData?.market});
        searchCriteriaList.push({field: 'productType', condition: '==', value: designDetailData?.productType});
        searchCriteriaList.push({field: 'category', condition: '==', value: designDetailData?.category});
        searchCriteriaList.push({field: 'name', condition: '==', value: designDetailData?.parent});

        searchParentProducts(searchCriteriaList)
            .then(async parentProductsList => {
                setParentProduct(parentProductsList[0]);
            });
    }

    const getQuoteById = async (quoteId) => {
        getSingleQuote(quoteId)
            .then(response => {
                const quoteDetailData = _.cloneDeep(response.data());
                quoteDetailData.id = quoteDetailData.id || designDetail?.quoteId;
                setQuoteDetail(quoteDetailData);
            });
    }

    const getPodDetailById = async (podId) => {
        getSinglePod(podId)
            .then(response => {
                const podDetailData = _.cloneDeep(response.data());
                setPodDetail(podDetailData);

                const tempProductColorMap = _.keyBy(podDetailData.colors, 'name');
                setProductColorMap(tempProductColorMap);
            });
    }

    const copyDesignVariantList = async (selectedDesignVariantList, selectedDesign, excludeTemplate?) => {
        setDataFetchInProgress(true);
        setCopiedVariantsCount(0);
        const existingDesignDetail = {...designDetail};
        const existingVariants = existingDesignDetail.variants || [];

        // console.log({selectedDesign, existingDesignDetail, selectedDesignVariantList,})

        let currentCount = 0;
        await Promise.mapSeries(selectedDesignVariantList, async selectedDesignVariant => {
            await copyFromDesignVariant(selectedDesignVariant, existingDesignDetail, existingVariants, selectedDesign, excludeTemplate);
            setCopiedVariantsCount(++currentCount);
        });

        existingDesignDetail.variants = existingVariants;
        processDesignVariantStatistics(existingDesignDetail);
        setDesignDetail(existingDesignDetail);

        await updateDesign(existingDesignDetail);
        setDataFetchInProgress(false);
    }

    const copyFromDesignVariant = async (currentDesignVariant, existingDesignDetail, existingVariants, selectedDesign, excludeTemplate?) => {
        const designVariantDetailData = await getSingleDesignVariant(currentDesignVariant?.id);
        const copiedDesignVariant = _.cloneDeep(designVariantDetailData.data());

        if (currentDesignVariant?.background) {
            copiedDesignVariant.settings.background = currentDesignVariant?.background;
        }

        if (excludeTemplate) {
            copiedDesignVariant.images = _.filter(copiedDesignVariant?.images, ['isTemplate', false]);
        }

        const newVariant: any = {};
        newVariant.designId = existingDesignDetail.id;
        newVariant.name = existingDesignDetail.name;
        newVariant.key = getNextItemKey(existingVariants, DESIGN_KEY_PREFIX.VARIANT);
        newVariant.status = 'in-design';

        if ((selectedDesign.parent === existingDesignDetail.parent) && currentDesignVariant.colors) {
            newVariant.colors = currentDesignVariant.colors;
        }

        processDesignVariantDetail(newVariant, designDetail, quoteDetail, parentProduct);
        processTextItemsLayer(newVariant);
        processApplyTemplateStyle(newVariant, copiedDesignVariant);

        processImagesLayer(newVariant);
        prepareImageFileName(newVariant, designDetail);

        const addedVariant: any = await addSingleDesignVariant(newVariant);
        newVariant.id = addedVariant.id;
        existingVariants.push(newVariant);
    }

    const duplicateDesignVariant = async (currentDesignVariant) => {
        setDataFetchInProgress(true);
        const existingDesignDetail = {...designDetail};
        const existingVariants = existingDesignDetail.variants || [];

        const designVariantDetailData = await getSingleDesignVariant(currentDesignVariant?.id);

        const duplicatedDesignVariant = _.cloneDeep(designVariantDetailData.data());
        const newVariant: any = {};
        newVariant.designId = existingDesignDetail.id;
        newVariant.name = existingDesignDetail.name;
        newVariant.key = getNextItemKey(existingVariants, DESIGN_KEY_PREFIX.VARIANT);
        newVariant.status = 'in-design';

        prepareImageFileName(newVariant, designDetail);

        duplicatedDesignVariant.key = newVariant.key;
        duplicatedDesignVariant.status = newVariant.status;

        delete duplicatedDesignVariant.colors;
        delete duplicatedDesignVariant.id;
        delete duplicatedDesignVariant.imageDetail;

        const addedVariant: any = await addSingleDesignVariant(duplicatedDesignVariant);
        newVariant.id = addedVariant.id;

        existingVariants.push(newVariant);
        existingDesignDetail.variants = existingVariants;
        processDesignVariantStatistics(existingDesignDetail);
        setDesignDetail(existingDesignDetail);

        await updateDesign(existingDesignDetail);
        handleSelectedVariant(newVariant);
        setDataFetchInProgress(false);
    }

    const addNewDesignVariant = async (designDetailData) => {
        setDataFetchInProgress(true);
        let existingDesignDetail = designDetailData;
        // const existingDesignDetail = {...designDetail};

        if (_.isEmpty(designDetailData)) {
            existingDesignDetail = {...designDetail};
        }

        const existingVariants = existingDesignDetail.variants || [];

        const newVariant: any = {};
        newVariant.designId = designId;
        newVariant.name = existingDesignDetail?.name;
        newVariant.key = getNextItemKey(existingVariants, DESIGN_KEY_PREFIX.VARIANT);
        newVariant.status = 'in-design';

        const addedVariant: any = await addSingleDesignVariant(newVariant);
        newVariant.id = addedVariant.id;

        existingVariants.push(newVariant);
        existingDesignDetail.variants = existingVariants;
        processDesignVariantStatistics(existingDesignDetail);
        setDesignDetail(existingDesignDetail);

        await updateDesign(existingDesignDetail);
        setDataFetchInProgress(false);
    }

    const updateVariantColorsInDesign = async (currentDesignVariant) => {
        const existingDesignDetail = {...designDetail};
        const existingVariants = existingDesignDetail.variants || [];

        const variantIndex = _.findIndex(existingVariants, ['key', currentDesignVariant.key]);
        existingVariants[variantIndex].colors = currentDesignVariant.colors;
        existingDesignDetail.variants = existingVariants;
        processDesignVariantStatistics(existingDesignDetail);
        setDesignDetail(existingDesignDetail);

        await updateDesign(existingDesignDetail);
    }

    const removeDesignVariant = async (currentDesignVariant) => {
        const existingDesignDetail = {...designDetail};
        const existingVariants = existingDesignDetail.variants || [];

        await deleteSingleDesignVariant(currentDesignVariant);

        const variantIndex = _.findIndex(existingVariants, ['key', currentDesignVariant.key]);
        delete existingVariants[variantIndex];
        existingDesignDetail.variants = _.compact(existingVariants);
        processDesignVariantStatistics(existingDesignDetail);
        setDesignDetail(existingDesignDetail);
        await updateDesign(existingDesignDetail);
    }

    const updateDesign = async (existingDesignDetail) => {
        await updateSingleDesign(existingDesignDetail);
    }

    const handleSelectedVariant = (variant) => {
        setSelectedVariant(variant);
        // setSelectedTab(DESIGN_EDITOR_TAB);
    }

    return (
        <>
            <div className="justify-center bg-gray-200 rounded dashboard-container">

                <div className="justify-start p-4">

                    <div className="items-center justify-start w-full mb-4">

                        <div className="flex items-center justify-start w-full mb-4">

                            <div className="w-full">

                                <div className="flex justify-start items-center mb-8">
                                    <ShowLink label="Back"
                                              url="/designs"/>

                                    <div className="ml-2 text-xl text-white rounded bg-purple-600 px-2 mr-2">
                                        Designer
                                    </div>

                                    {designDetail &&
                                        <>
                                            <ShowDesignDetail designDetail={designDetail}/>
                                        </>
                                    }
                                </div>

                                {parentProduct &&
                                    <div className="-mt-6">
                                        <ShowParentProductColorList parentProduct={parentProduct}/>
                                    </div>
                                }

                            </div>

                            <div className="w-1/6 flex">
                                <DownloadDesignVariants
                                    designDetail={designDetail}
                                    parentProduct={parentProduct}
                                    isAssignColors={undefined}
                                    isPreview={undefined}
                                    isLightButton={false}
                                    updateVariantColorsInDesign={undefined}
                                    setDesignDetail={setDesignDetail}/>

                                <div className="flex items-center justify-center ml-2">
                                    <a href={`/designs/${designDetail?.id}/publish`}
                                       className={`button-outline-small flex w-full justify-center ${designDetail?.statistics?.readyToPublish > 0 ? 'button-green' : ''}`}>
                                        <div>Publish</div>
                                    </a>
                                </div>
                            </div>

                        </div>

                    </div>

                    <div className="">
                        <ShowTabsList
                            setSelectedTab={setSelectedTab}
                            selectedTab={selectedTab}
                            tabsList={tabsList}/>
                    </div>

                    <div className="mt-4 px-8">

                        {selectedTab?.key === 'variants' &&
                            <div>
                                {/*<DesignVariantCardList
                                    addNewDesignVariant={addNewDesignVariant}
                                    handleSelectedVariant={handleSelectedVariant}
                                    designDetail={designDetail}
                                    removeDesignVariant={removeDesignVariant}/>*/}
                                <DesignVariantItemList
                                    updateVariantColorsInDesign={updateVariantColorsInDesign}
                                    duplicateDesignVariant={duplicateDesignVariant}
                                    copyDesignVariantList={copyDesignVariantList}
                                    allTags={allTags}
                                    designDetail={designDetail}
                                    selectedVariant={selectedVariant}
                                    quoteDetail={quoteDetail}
                                    parentProduct={parentProduct}
                                    setDesignDetail={setDesignDetail}
                                    addNewDesignVariant={addNewDesignVariant}
                                    handleSelectedVariant={handleSelectedVariant}
                                    removeDesignVariant={removeDesignVariant}
                                    dataFetchInProgress={dataFetchInProgress}
                                    selectedDesignBatchId={selectedDesignBatchId}
                                    setSelectedDesignBatchId={setSelectedDesignBatchId}
                                />
                            </div>
                        }

                        {/*{selectedTab?.key === 'editor' && quoteDetail && parentProduct && selectedVariant &&
                            <div>
                                <Editor
                                    updateVariantColorsInDesign={updateVariantColorsInDesign}
                                    duplicateDesignVariant={duplicateDesignVariant}
                                    allTags={allTags}
                                    designDetail={designDetail}
                                    selectedVariant={selectedVariant}
                                    quoteDetail={quoteDetail}
                                    parentProduct={parentProduct}
                                    setDesignDetail={setDesignDetail}/>
                            </div>
                        }*/}

                        {selectedTab?.key === 'parent-product' && parentProduct &&
                            <div className="w-full">
                                <ParentProductDetail
                                    parentProduct={parentProduct}
                                    setParentProduct={setParentProduct}
                                    allTags={allTags}/>
                            </div>
                        }

                    </div>


                </div>

            </div>
        </>
    )
}

export default DesignEditor
